// extracted by mini-css-extract-plugin
export var phone = "_55-0";
export var phoneDragging = "_55-1";